import React from 'react';
import styled from 'App/styled';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { Policy } from '@nykaa/remote-config/types';

const NavigationWrap = styled.ul`
  background-color: ${(props) => props.theme.brandPrimary};
  color: #ffffff;
  border-top: 1px solid #fff;
  text-align: center;
  line-height: 18px;
  padding: 16px;
  list-style: none;
  margin: 0;
`;

const NavigationItem = styled.li`
  display: inline-block;
`;

const NavigationLink = styled.a`
  ${({ theme }) => theme.typography.subTitleSmall};
  color: #fff;
  text-decoration: none;
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.spacing0}
    ${({ theme }) => theme.spacing.spacing60};
  margin: ${({ theme }) => theme.spacing.spacing0};
`;

const Navigation = () => {
  const { policies = [] } = useSelector(
    (state: State) => state.remoteConfig.configs
  );

  if (!(Array.isArray(policies) && policies.length)) return null;

  return (
    <NavigationWrap>
      {policies.map((policy: Policy) => (
        <NavigationItem key={policy.link}>
          <NavigationLink
            href={policy.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {policy.title}
          </NavigationLink>
        </NavigationItem>
      ))}
    </NavigationWrap>
  );
};
export default Navigation;
